<template>
	<div v-if="device=='pc'">
		<box :customer="true" :autoLoad="false" :ref="boxRef" title="请选择" :width="1000" :index="0" moduleName="moduleName" @hide="hide"
			@submit="submit" :store="store" selectType="checkbox" @boxdataload="boxdataload" />		
	</div>
	<div v-else>
		<phonebox :customer="true" :autoLoad="false" :ref="boxRef" title="请选择" :width="1000" :index="0" moduleName="moduleName" @hide="hide"
			@submit="submit" :store="store" selectType="checkbox" @boxdataload="boxdataload" />
	</div>
</template>	
<style scoped>
	/* 	.footer_button {
		position: relative;
		width: 100%;
		flex-direction: row;
		align-items: flex-end;
		justify-content: flex-end;
		margin-top: 10px;
	} */
</style>
<script>
	import box from '@_system/components/formcomponents/common/box/index.vue'
	export default {
		props: {
			store: {
				type: Object,
				default: () => {
					return {}
				}
			},
			data: {
				type: Array,
				default: () => {
					return []
				}
			},
			sourceStoreUids:{
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				index: 0,
				foreingKey: null,
				boxRef: 'box_' + Math.random(),
				box: null,
				boxConfig: {
					columns: [{
						field: 'supplier',
						title: '供应商',
						visible:false,
						props:{
							emptyoption:false
						},
						render:'$supplier'
					},{
						field: 'bestsupplier',
						title: '最优供应商',
					},{
						field: 'spec_code',
						title: '商品编码',	
					},{
						field: 'itemName',
						title: '商品名称',
					},{
						field: 'skuName',
						title: '商品型号',
					},{
						field: 'recommendlevel',
						title: '推荐等级',
					},{
						field: 'lock',
						title: '需求量',
					},{
						field: 'quantity',
						title: '实际库存',
					},{
						field: 'availableStock',
						title: '可用库存',
					},{
						field: 'underway',
						title: '在途库存',
					},{
						field: 'warehousecode',
						title: '仓库编码',
					},{
						field: 'lower',
						title: '下限',
					},{
						field: 'upper',
						title: '上限',
					},{
						field: 'type',
						title: '策略类型',
					}],
					pagerConfig: {
						currentPage: 1,
						pageSize: 20,
						enabled: false,
						pageSizes: [10,20, 50, 200],
						force: false
					},
				},

			}
		},
		created() {

		},
		mounted() {
			let box = this.$refs[this.boxRef]
			box.buttonShow = false
			this.box = box
			this.box.list = this.list
			// this.box.show = this.show
			// this.box.checkMethod = ({
			// 	row
			// }) => {
			// 	return !row.reconciliationbilldetailid
			// }

		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},

		methods: {
		
			initList() {
				if (!this.box.gridOptions) {
					this.box.initBox(this.boxConfig)
				}
			},
			list(page, form, other) {
				// console.log(page, form, other)
				return new Promise((resolve,reject) => {
					// resolve({list:data})
					this.$api.purchase.suppliergrouppurchase({
						mode: 'box',
						sourceStoreUids:this.sourceStoreUids,
						index: this.index,
						...page,
						...form,
						...this.foreingKey,
						...other
					}).then((res) => {
						resolve({list:res})
					}, () => {
						reject()
					})
				})
			},
			boxdataload(e) {
				this.$emit('boxdataload', e)
			},
			submit(e) {
				this.$emit('submit', e)
			},
			hide() {
				this.$emit('back')
			}
		},
		components: {
			box
		}
	}
</script>